import React, { useCallback, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, useTheme } from '@web-chat-core/ui-kit';
import ModalOverlay from '@web-chat-core/ui-kit/core/ModalOverlay';
import { useModal } from 'useCase/modal/useModal';
import { selectIsModalOpened } from 'state/selectors';
import { ModalName } from 'features/Modals/ModalProvider';

export const KickedModal = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();
    const { closeModal } = useModal();
    const isOpen = selectIsModalOpened(ModalName.KICKED);
    const wasOpenRef = useRef(false);

    const removeKickedParamFromUrl = useCallback(() => {
        const urlParams = new URLSearchParams(location.search);
        urlParams.delete('kicked');
        const search = urlParams.toString() ? `?${urlParams.toString()}` : '';
        if (search) {
            history.replace({ pathname: location.pathname, search });
        } else {
            history.replace(location.pathname);
        }
    }, [history, location.pathname, location.search]);

    const handleClose = useCallback(() => {
        removeKickedParamFromUrl();
        closeModal();
    }, [closeModal, removeKickedParamFromUrl]);

    useEffect(() => {
        if (isOpen) {
            wasOpenRef.current = true;
        } else if (wasOpenRef.current) {
            wasOpenRef.current = false;
            removeKickedParamFromUrl();
        }
    }, [isOpen, removeKickedParamFromUrl]);

    if (!isOpen) {
        return null;
    }

    return (
        <ModalOverlay name="kicked-modal" onClick={handleClose} isNeedOverlay={true}>
            <ModalBody
                width="400px"
                style={{
                    background: theme.root.colors.background.sheetOrModal,
                }}
            >
                <ModalHeader
                    title={t('web_videoconference_moderator_user_removed_from_meeting')}
                    onClose={handleClose}
                />
                <ModalContent />
                <ModalFooter>
                    <Button variant="primary" onClick={handleClose}>
                        {t('web_videoconference_AI_Assistant_onbording_button')}
                    </Button>
                </ModalFooter>
            </ModalBody>
        </ModalOverlay>
    );
};
